import { Type } from 'class-transformer';
import {
  IsInt,
  IsUUID,
  IsNotEmpty,
  IsOptional,
  Min,
  IsString,
} from 'class-validator';

export class GetManagerSubstitutesDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsOptional()
  @IsString()
  searchEmployee?: string;

  @IsOptional()
  @IsInt()
  @Min(0)
  @Type(() => Number)
  offset = 0;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Type(() => Number)
  // eslint-disable-next-line no-magic-numbers
  limit = 20;
}
